const security = require('../security.js');

module.exports = ['$httpProvider', ($httpProvider) => {
  // The session interceptor manage user' session with token providing and expiration.
  $httpProvider.interceptors.push([
    '$local',
    '$q',
    '$rootScope',
    ($local, $q, $rootScope) => ({
      responseError(response) {
        let error = null;

        if (response.data && response.data.error && typeof response.data.error === 'string') {
          error = response.data.error.replace('api.errors.', '');
        }

        if (response.status === 401) {
          $rootScope.$emit('application:out', { error });
        }

        return $q.reject(response);
      },
    }),
  ]);

  // Log http requests detail in back-end
  $httpProvider.interceptors.push([
    '$local',
    '$q',
    function (
      $local,
      $q,
    ) {
      return {
        request(config) {
          config.startedAt = +moment();
          return config;
        },

        responseError(response) {
          if (response
            && response.config
            && response.config.url.endsWith('/session')
          ) {
            return response;
          }
          return $q.reject(response);
        },
      };
    },
  ]);
}];



// WEBPACK FOOTER //
// ./main/config/initializers/interceptors.js